import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

// MODELOS
import {
  CompanyModel, CompanyModelResponse, AlertModel, AlertToCompanyModelResponse,
  AssignAlertToCompany, CompanyAlertListResponse, UpdateCompanyModel
} from './../models/index'
import { environment } from 'src/environments/environment';
import { Form, FormGroup } from '@angular/forms';
import { CompaniesResponse, AlertListResponse, SapConnResponse } from '../models/responses';

// RUTAS
// COMPONENTES
// SERVICIOS
import { StorageService } from '../services/storage.service'

@Injectable({
  providedIn: 'root'
})
export class ConfigParamsService {

  constructor(private http: HttpClient,
    private storageService: StorageService) { }

  // obtiene lista de companias
  getCompanyList() {
    const TOKEN = this.storageService.getToken();
    const URL = `${environment.apiUrl}/api/Company/GetCompanyList`;
    console.log(URL);
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.get<CompaniesResponse>(URL,{ headers });
  }

  // obtiene lista de companias
  getSapConnList() {
    const TOKEN = this.storageService.getToken();
    const URL = `${environment.apiUrl}/api/ConfigParams/GetSapConn`;
    console.log(URL);
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.get<SapConnResponse>(URL,{ headers });
  }

  // obtiene lista de alertas
  getAlertList() {
    const TOKEN = this.storageService.getToken();
    const URL = `${environment.apiUrl}/api/Alert/GetAlerts`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.get<AlertListResponse>(URL,{ headers });
  }

  // obtiene lista de alertas+compania
  getCompanyAlertList() {
    const TOKEN = this.storageService.getToken();
    const URL = `${environment.apiUrl}/api/ConfigParams/GetCompanyAlertList`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.get<CompanyAlertListResponse>(URL,{ headers });
  }

  // envia la info de la compania para crearla
  createCompany(CreateCompanyForm: FormGroup) {
    const TOKEN = this.storageService.getToken();   
    const CompanyModel: CompanyModel = {
      Id: 0,
      DbCode: CreateCompanyForm.controls['dbCode'].value,
      CompanyName: CreateCompanyForm.controls['companyName'].value,
      SAPConnectionId: CreateCompanyForm.controls['sapConnectionId'].value,
      //SAPServer: CreateCompanyForm.controls['sapServer'].value,
      Active: CreateCompanyForm.controls['active'].value,
      ReportPathCompany: CreateCompanyForm.controls['companyReportName'].value,
      ReportPathBusinessPartner: CreateCompanyForm.controls['businessPartnerReportName'].value,
      ReportPathSupplier: CreateCompanyForm.controls['supplierReportName'].value,
      EmailTo: CreateCompanyForm.controls['emailTo'].value,
      EmailCC: CreateCompanyForm.controls['emailCc'].value,
      InternalEmailReport: CreateCompanyForm.controls['InternalEmailReport'].value
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.post<CompanyModelResponse>(`${environment.apiUrl}/api/ConfigParams/CreateCompany`,
    CompanyModel,
      { headers }
    );
  }

  // envia la info de la compania para crearla
  updateCompany( companyInEdition: CompanyModel, CreateCompanyForm: FormGroup) {
    const TOKEN = this.storageService.getToken();  
    console.log("updateCompanyService");   
    const CompanyModel: UpdateCompanyModel = {
      Id: companyInEdition.Id,
      DbCode: CreateCompanyForm.controls['dbCode'].value,
      CompanyName: CreateCompanyForm.controls['companyName'].value,
      SAPConnectionId: CreateCompanyForm.controls['sapConnectionId'].value,
      Active: CreateCompanyForm.controls['active'].value,
      ReportPathCompany: CreateCompanyForm.controls['companyReportName'].value,
      ReportPathBusinessPartner: CreateCompanyForm.controls['businessPartnerReportName'].value,
      ReportPathSupplier: CreateCompanyForm.controls['supplierReportName'].value,
      EmailTo: CreateCompanyForm.controls['emailTo'].value,
      EmailCC: CreateCompanyForm.controls['emailCc'].value,
      InternalEmailReport: CreateCompanyForm.controls['InternalEmailReport'].value
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.post<CompanyModelResponse>(`${environment.apiUrl}/api/ConfigParams/UpdateCompany`,
    CompanyModel,
      { headers }
    );
  }

  // envia la info de la alerta para crearla
  updateAlert(AlertModel: AlertModel, createAlertForm: FormGroup) {
    const TOKEN = this.storageService.getToken();   
    console.log("createAlert");  
    AlertModel.EmailBody = createAlertForm.controls['emailBody'].value;
    AlertModel.EmailSubject = createAlertForm.controls['emailSubject'].value;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.post<AlertToCompanyModelResponse>(`${environment.apiUrl}/api/ConfigParams/UpdateAlert`,
    AlertModel,
      { headers }
    );
  }

  // envia la info de la alerta para crearla
  createAssignAlertToCompany(createAlertForm: FormGroup) {
    const TOKEN = this.storageService.getToken();  
    console.log("createAssignAlertToCompany"); 
    const assignInfo: AssignAlertToCompany = {
      CompanyId: createAlertForm.controls['companyId'].value,
      AlertId: createAlertForm.controls['alertId'].value
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.post<AlertToCompanyModelResponse>(`${environment.apiUrl}/api/ConfigParams/AssignAlertToCompany`,
    assignInfo,
      { headers }
    );
  }

  //#region PROVEEDOR
  // obtiene lista de companias
  getManagerList() {
    const TOKEN = this.storageService.getToken();
    const URL = `${environment.apiUrl}/api/Manager/GetManagers`;
    console.log(URL);
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.get<any>(URL,{ headers });
  }
  
  // obtiene lista de correos de los gestores
  getEmailManagerList() {
    const TOKEN = this.storageService.getToken();
    const URL = `${environment.apiUrl}/api/ConfigParams/GetEmailManagerConfigList`;
    console.log(URL);
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.get<any>(URL,{ headers });
  }

  // obtiene lista usuarios
  getUserList() {
    console.log('GetUserList---');
    const TOKEN = this.storageService.getToken();
    const URL = `${environment.apiUrl}/api/ConfigParams/GetUserList`;
    console.log(URL);
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.get<any>(URL,{ headers });
  }

  // envia la info del gestor para actualizarla
  updateManager( managerInEdition: any, UpdateManagerForm: FormGroup) {
    const TOKEN = this.storageService.getToken();  
    console.log("updateCompanyService");   
    const UpdateManager: any = {
      Id: UpdateManagerForm.controls['managerSelected'].value,
      ManagerName: UpdateManagerForm.controls['managerName'].value,
      Email: UpdateManagerForm.controls['managerEmail'].value,
      Password: UpdateManagerForm.controls['managerPassword'].value,
      Host: UpdateManagerForm.controls['managerHost'].value,
      Port: UpdateManagerForm.controls['managerPort'].value,
      SSL: UpdateManagerForm.controls['managerSSL'].value,
      Active: UpdateManagerForm.controls['managerStatus'].value
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.post<any>(`${environment.apiUrl}/api/Manager/UpdateManager`,
    UpdateManager,
      { headers }
    );
  }

  // envia la info del gestor para crear
  createManager(CreateManagerForm: FormGroup) {
    const TOKEN = this.storageService.getToken();   
    const CreateManager: any = {
      Id: 0,
      UserMisSec: CreateManagerForm.controls['userSelected'].value,
      ManagerName: CreateManagerForm.controls['managerName'].value,
      Email: CreateManagerForm.controls['managerEmail'].value,
      Password: CreateManagerForm.controls['managerPassword'].value,
      Host: CreateManagerForm.controls['managerHost'].value,
      Port: CreateManagerForm.controls['managerPort'].value,
      SSL: CreateManagerForm.controls['managerSSL'].value,
      Active: CreateManagerForm.controls['managerStatus'].value,
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.post<any>(`${environment.apiUrl}/api/Manager/CreateManager`,
    CreateManager,
      { headers }
    );
  }

  // obtiene lista de companias
  getCompanysByManager(ManagerId: number) {
    const TOKEN = this.storageService.getToken();
    const URL = `${environment.apiUrl}/api/Company/GetCompanyList`; //GetCompanysByManager?ManagerId=${ManagerId}
    console.log(URL);
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.get<CompaniesResponse>(URL,{ headers });
  }

  // obtiene lista de companias
  getCompanysByManager2(ManagerId: string) {
    console.log('------------')
    const TOKEN = this.storageService.getToken();
    const URL = `${environment.apiUrl}/api/Company/GetCompanysByManager?ManagerId=${ManagerId}`; //
    console.log(URL);
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.get<CompaniesResponse>(URL,{ headers });
  }

  // obtiene lista de companias disponibles para el gestor
  getCompaniesAvailable() {
    const TOKEN = this.storageService.getToken();
    const URL = `${environment.apiUrl}/api/Company/GetAvailableCompanyList`;
    console.log(URL);
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.get<CompaniesResponse>(URL,{ headers });
  }

  // crea una nueva asignacion de gestor con una compania
  createManagerByCompanies(managerByCompanyForm: FormGroup, managerCompanyList: Array<any>) {
    const TOKEN = this.storageService.getToken();
    let CompaniesId: string = ''; 
    managerCompanyList.forEach(function(company,ind){  
      CompaniesId = (ind === 0) ? String(`${company.IdCompany }`) : String(`${CompaniesId},${company.IdCompany}`);
    });    
    const NewManagerByCompany: any = {
      IdManager: managerByCompanyForm.controls['selectedManager'].value,
      CompaniesId: CompaniesId
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${TOKEN}`
    });
    return this.http.post<any>(`${environment.apiUrl}/api/Manager/CreateManagerByCompanies`,
    NewManagerByCompany,
      { headers }
    );
  }
  //#endregion PROVEEDOR
}
